var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"loader",staticClass:"loader"},[_c('img',{staticClass:"loader__image",attrs:{"src":_vm.requireAsset('loaders/loader.gif'),"alt":""},on:{"load":function($event){return _vm.setCarga()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }